import "../../styles/Admin.css"
import { Dialog, Tab } from "@headlessui/react"
import { KTitleSpan, KButton, KDropdown, KInput, KSpan, KTooltip } from "kahuna-base-react-components"
import React, { useEffect, useState } from "react"
import { lang } from "../../../../../constants/languages"
import { KSelectOption } from "kahuna-base-react-components/dist/components/KDropdown/KDropdown"
import { User, UserExpense, UserExpenseForm, UserForm } from "../../../../../types"
import { connect } from "react-redux"
import {
  fetchUserExpenseData,
  paymentMethodsAdminEntry,
  saveUser,
  saveUserExpenseData,
  selectUser,
  updateUserHasUpdateCount,
  updateUserUnverifiedContractCount,
  updateUserPaymentMethodUpdatedCount
} from "../../../../../actions/adminActions"
import { RootState } from "../../../../../store"
//@ts-ignore
import EyeIconGray from "../../../../../assets/admin_icons/eye-gray.svg"
//@ts-ignore
import EyeClosedIcon from "../../../../../assets/admin_icons/eye-closed-gray.svg"
//@ts-ignore
import CheckCircle from "../../../../../assets/admin_icons/check-circle.svg"
//@ts-ignore
import CloseCircle from "../../../../../assets/admin_icons/close-circle.svg"
import {
  errorFilledToastOptions,
  successFilledToastOptions,
  successStrokeToastOptions,
  superAdminSelectOption,
  USER_MEMBER_TYPE,
  USER_PERMISSION,
  USER_ROLE,
  userRoleOptions
} from "../../../../../constants"
import ToggleInput from "../../../../ui/components/ToggleInput"
import { toast } from "react-toastify"
import adminUserValidator from "./validators/adminUserValidator"
import { handleAuthorizedRequest, releases, users } from "../../../../../apis"
import { generateStrongPassword } from "../../../../../utility"
import AdminAgreementsPayoutModal from "./AdminAgreementsPayoutModal"
import { X } from "heroicons-react"
import AdminSmartLinkArtistModal from "./AdminSmartLinkArtistModal"
import AdminUserCreditModal from "./AdminUserCreditModal"

const countryOptions: KSelectOption[] = [
  { label: "TR", value: 1 },
  { label: "GB", value: 2 }
]

enum TabOptions {
  DETAIL = "Detail",
  USER_CREDITS = "User Credits",
  AGREEMENTS_PAYOUT = "Agreements & Payout",
  SMART_LINK_ARTIST = "Smart Link - Artist"
}

const AdminUserCreateModal = ({
  open,
  onClose,
  selectedUser,
  loggedInUser,
  saveUser,
  selectUser,
  isEdit,
  setGenre,
  paymentMethodsAdminEntry,
  saveUserExpenseData,
  selectedUserExpense,
  fetchUserExpenseData,
  userHasUpdateCount,
  updateUserHasUpdateCount,
  userUnverifiedContractCount,
  updateUserUnverifiedContractCount,
  userPaymentMethodUpdatedCount,
  updateUserPaymentMethodUpdatedCount
}: {
  open: boolean
  onClose: () => void
  selectedUser: User
  loggedInUser: User
  saveUser: (formValues: UserForm) => Promise<void>
  selectUser: (user: User | null) => void
  isEdit?: boolean
  setGenre?: (genre: string) => void
  paymentMethodsAdminEntry?: (userId?: number) => void
  saveUserExpenseData: (formValues: UserExpenseForm) => Promise<void>
  selectedUserExpense: UserExpense
  fetchUserExpenseData: (userId: number) => Promise<void>
  userHasUpdateCount: number
  updateUserHasUpdateCount: (userHasUpdateCount: number) => void
  userUnverifiedContractCount: number
  updateUserUnverifiedContractCount: (userUnverifiedContractCount: number) => void
  userPaymentMethodUpdatedCount: number
  updateUserPaymentMethodUpdatedCount: (userPaymentMethodUpdatedCount: number) => void
}) => {
  const createUserFormFromUser = (selectedUser: User): UserForm => {
    return {
      id: selectedUser?.id,
      username: selectedUser?.username,
      firstName: selectedUser?.firstName,
      lastName: selectedUser?.lastName,
      password: "",
      roleId: selectedUser?.roleId,
      permissionIds: selectedUser?.permissionUser?.map((pu) => pu.permission.id),
      lcUsername: selectedUser?.lcUsername,
      lcPassword: "",
      sendEmail: !selectedUser?.id ? true : false,
      bmwCustomId: selectedUser?.bmwCustomId,
      validateEmail: selectedUser?.validateEmail,
      genre: selectedUser?.genre,
      company: selectedUser?.company,
      artistSpotifyId: selectedUser?.artistSpotifyId,
      excludeFromProjection: selectedUser?.excludeFromProjection || false,
      excludeFromPortfolio: selectedUser?.excludeFromPortfolio || false,
      hideReportTotalAmount: selectedUser?.hideReportTotalAmount === false ? false : true
    }
  }

  const [loading, setLoading] = useState(false)
  const [userInformations, setUserInformations] = useState<UserForm>(createUserFormFromUser(selectedUser))
  const [checkLabelCamp, setCheckLabelCamp] = useState<boolean | undefined>(undefined)
  const [genreOptions, setGenreOptions] = useState<KSelectOption[]>([])
  const [labelList, setLabelList] = useState<KSelectOption[]>([])
  const [labelOptions, setLabelOptions] = useState<KSelectOption[]>([])
  const [timeoutId, setTimeoutId] = useState<number>()
  const [searchLabel, setSearchLabel] = useState("")
  const [labelCampLoading, setLabelCampLoading] = useState(false)
  const [labelsFetched, setLabelsFetched] = useState(false)
  const [userMemberOptions, setUserMemberOptions] = useState<KSelectOption[]>([])
  const [userTimeoutId, setUserTimeoutId] = useState<number>()
  const [selectedUserAdvanceMembers, setSelectedUserAdvanceMembers] = useState<string[]>([])
  const [selectedUserLabelMembers, setSelectedUserLabelMembers] = useState<KSelectOption[]>([])
  const [selectedTab, setSelectedTab] = useState<TabOptions>(TabOptions.DETAIL)

  const [showPassword, setShowPassword] = useState<{ userPassword: boolean; lcPassword: boolean }>({
    userPassword: false,
    lcPassword: false
  })

  const roleOptions =
    loggedInUser?.roleId === USER_ROLE.SuperAdmin
      ? userRoleOptions.filter((option) => option.value !== USER_ROLE.SuperAdmin)
      : userRoleOptions.filter(
          (option) => option.value !== USER_ROLE.SuperAdmin && option.value !== USER_ROLE.DistroAdmin
        )

  useEffect(() => {
    setLabelList([])
    setUserInformations(createUserFormFromUser(selectedUser))
    setLabelsFetched(false)
    setSelectedUserAdvanceMembers(
      selectedUser.userMembers
        ?.filter((option) => option.type === USER_MEMBER_TYPE.ADVANCE)
        .map((option) => `${option.firstName} ${option.lastName} (${option.email})`) || []
    )
    setSelectedUserLabelMembers(
      selectedUser.userMembers
        ?.filter((option) => option.type === USER_MEMBER_TYPE.LABEL)
        .map((option) => {
          return {
            value: option.id || 0,
            label: `${option.firstName} ${option.lastName} (${option.email})`,
            type: option.type
          }
        }) || []
    )
  }, [selectedUser])

  useEffect(() => {
    if (genreOptions.length === 0) {
      releases(`/release/label_camp_genre_options/`, "get").then((resp) => {
        setGenreOptions(
          resp.data["distributor_product_sub_genre_options"].map((option: any, index: number) => {
            return { label: option.label, value: index, value2: option.value }
          })
        )
      })
    }
  }, [])

  useEffect(() => {
    if (selectedTab === TabOptions.AGREEMENTS_PAYOUT && selectedUser.id) {
      fetchUserExpenseData(selectedUser.id)
    }
  }, [selectedTab, selectedUser])

  useEffect(() => {
    if (setGenre && selectedUser) {
      const genre = genreOptions.find((option: KSelectOption) => option?.value2 === selectedUser?.genre)
      setGenre(genre?.label || "-")
    }
  }, [genreOptions])

  const handleInput = (field: keyof UserForm, value: string | number | boolean) => {
    const currentState = { ...userInformations }
    setUserInformations({ ...currentState, [field]: value })
  }

  const handlePermissionChange = (permissionId: number) => {
    const currentPermissions = userInformations?.permissionIds || []
    const newPermissions = currentPermissions.includes(permissionId)
      ? currentPermissions.filter((id) => id !== permissionId)
      : [...currentPermissions, permissionId]
    setUserInformations({ ...userInformations, permissionIds: newPermissions })
  }

  const checkPermission = (permissionId: number) => {
    return userInformations?.permissionIds?.includes(permissionId)
  }

  const onUserFormSubmit = async (values: UserForm) => {
    if (
      values?.permissionIds &&
      values?.permissionIds.includes(USER_PERMISSION.UPLOAD_MESAM) &&
      values?.permissionIds.includes(USER_PERMISSION.UPLOAD_MSG)
    ) {
      toast.error("Choose one: Mesam / Msg", errorFilledToastOptions)
      return
    }
    let lcUsername = values.lcUsername
    if (
      lcUsername &&
      !lcUsername.includes("@kahunareach.com") &&
      !lcUsername.includes("@gmail.com") &&
      !lcUsername.includes("@kahuna.com.tr")
    ) {
      lcUsername = `${lcUsername}@kahunareach.com`
    }

    const newUserMemberIds = selectedUserLabelMembers.map((option) => option.value).sort((a, b) => a - b)
    const existedUserLabelMemberIds =
      selectedUser.userMembers
        ?.filter((option) => option.type === USER_MEMBER_TYPE.LABEL)
        .map((option: User) => option.id)
        ?.sort((a, b) => (a || 0) - (b || 0)) || []

    if (newUserMemberIds.toString() !== existedUserLabelMemberIds.toString()) {
      users("/save_user_members/", "post", { main_user_id: selectedUser.id, attached_user_id_list: newUserMemberIds })
        .then((resp) => {
          if (resp.data.success) {
            toast.success(
              "Successfull updated user members. Refresh the page to see results",
              successStrokeToastOptions
            )
          } else {
            toast.error("Error updating user members", errorFilledToastOptions)
          }
        })
        .catch(() => toast.error("Error updating user members", errorFilledToastOptions))
    }

    setLoading(true)
    saveUser({ ...values, lcUsername })
      .then(() => setLoading(false))
      .catch(() => setLoading(false))
  }

  const onSearchLabel = (text: string) => {
    releases(`/release/label_camp_label_options/?search=${text}`, "get").then((resp) => {
      setLabelOptions(
        resp.data.results.map((option: any) => {
          return { label: option.label, value: option.value }
        })
      )
    })
  }

  const handleLabelInputChange = (text: string) => {
    setSearchLabel(text)
    if (timeoutId) {
      clearTimeout(timeoutId)
    }

    const newTimeoutId = setTimeout(() => {
      // Call onSearch after 1 second
      onSearchLabel(text)
    }, 1000)

    setTimeoutId(newTimeoutId)
  }

  const handleClose = () => {
    setSelectedTab(TabOptions.DETAIL)
    onClose()
    setCheckLabelCamp(undefined)
  }

  const onUserExpenseFormSubmit = async (values: UserExpenseForm) => {
    saveUserExpenseData(values)
  }

  const checkLabelCampInformations = async (
    userId: number | undefined,
    lcUsername: string | undefined,
    lcPassword: string
  ) => {
    const requestPayload: { user_id: number | undefined; lc_username: string | undefined; lc_password?: string } = {
      user_id: userId,
      lc_username: lcUsername
    }

    if (lcPassword) requestPayload.lc_password = lcPassword

    try {
      const response = await users(`/check_label_camp_information/`, "post", requestPayload)
      if (!response.data.success) {
        setCheckLabelCamp(false)
        toast.error("There is no labelcamp account with these credentials", errorFilledToastOptions)
      } else {
        setCheckLabelCamp(true)
        toast.success("Valid account", successFilledToastOptions)
      }
    } catch {
      setCheckLabelCamp(false)
      toast.error("Error on checking labelcamp information", errorFilledToastOptions)
    }
  }

  const checkLabelCampUserLabel = async (id?: number) => {
    if (!id) return

    setLabelCampLoading(true)
    releases(`/release/label_camp_user_label/?user_id=${id}`, "get")
      .then((response) => {
        setLabelCampLoading(false)
        if (response.data.results) {
          setLabelList(response.data.results)
          setLabelsFetched(true)
        } else {
          toast.error(`Error: ${response.data.message}`, errorFilledToastOptions)
        }
      })
      .catch((err) => {
        toast.error("Error Fetching labels", errorFilledToastOptions)
        setLabelCampLoading(false)
      })
  }

  const updateLabelCampUserLabel = async (id?: number) => {
    const promtText =
      "Are you sure you want to insert all the labels. DELETE is not available. Only Insert. You can delete using Labelcamp dashboard."

    if (!window.confirm(promtText)) return
    if (!id) return

    setLabelCampLoading(true)
    const labelIdList = labelList.map((label) => label.value).join(",")

    const response = await releases(
      `/release/label_camp_user_label_update/?user_id=${id}&label_id_list=${labelIdList}`,
      "put"
    )
    setLabelCampLoading(false)
    if (response.data.results && !response.data.message) {
      setLabelList(response.data.results)
      setLabelsFetched(false)
      toast.success("Successfully added labels", successFilledToastOptions)
    } else if (response.data.results & response.data.message) {
      toast.info(`Partial Success / Error: ${response.data.message}`, errorFilledToastOptions)
    } else if (response.data.message) {
      toast.info(`Error: ${response.data.message}`, errorFilledToastOptions)
    }
  }

  const getInvitationEmailUrl = async (username?: string) => {
    if (!username) return

    const kahunaReachUsername = `${username}@kahunareach.com`

    setLabelCampLoading(true)
    const response = await users(`/label_camp_invitation_url/?username=${kahunaReachUsername}`, "get")
    setLabelCampLoading(false)
    if (response.data) {
      window.open(response.data, "_blank")
    } else {
      toast.error(
        `Invitation url not exist or not found. If you are sure, you can check email adress directly.`,
        errorFilledToastOptions
      )
    }
  }

  const createLcUser = async (username: string, password: string) => {
    if (!username || labelList.length === 0) return
    if (username.includes("@") && !username.includes("@kahunareach.com")) {
      toast.error("@ not allowed")
      return
    }
    const kahunaReachUsername = username.includes("@kahunareach.com") ? username : `${username}@kahunareach.com`

    setLabelCampLoading(true)
    users(
      `/label_camp_create_user/?username=${kahunaReachUsername}&password=${password}&label_id_list=${labelList
        .map((label) => label.value)
        .join(",")}`,
      "post"
    )
      .then((response) => {
        setLabelCampLoading(false)
        if (response.data.success) {
          toast.success(
            "Label Camp User created successfully. Check invitation email to setup password.",
            successFilledToastOptions
          )
        } else {
          toast.error(`Error: ${response.data.message}`, errorFilledToastOptions)
        }
      })
      .catch((err) => {
        toast.error(`Error: ${err}`, errorFilledToastOptions)
        setLabelCampLoading(false)
      })
  }

  const renderNewReleasePermissions = () => {
    const isNewRelease = checkPermission(USER_PERMISSION.NEW_RELEASE)
    return (
      <div className="flex flex-col gap-0 bg-[#F7F7F7] rounded-[10px]">
        <div className="flex flex-row gap-2 px-3.5 py-2 items-center">
          <ToggleInput
            data-testid="new-release-permission-toggle"
            checked={checkPermission(USER_PERMISSION.NEW_RELEASE)}
            handleChange={() => {
              handlePermissionChange(USER_PERMISSION.NEW_RELEASE)
            }}
          />
          <KSpan
            text="New Release"
            color="#000"
            fontWeight={checkPermission(USER_PERMISSION.NEW_RELEASE) ? 500 : 400}
          />
        </div>
        <div className="flex flex-row gap-2 px-3.5 py-2 items-center">
          <ToggleInput
            checked={checkPermission(USER_PERMISSION.UPLOAD_MSG)}
            handleChange={() => {
              handlePermissionChange(USER_PERMISSION.UPLOAD_MSG)
            }}
            disabled={!checkPermission(USER_PERMISSION.NEW_RELEASE)}
          />
          <KSpan
            text="Upload MSG"
            color={isNewRelease ? "#000" : "#00000024"}
            fontWeight={checkPermission(USER_PERMISSION.UPLOAD_MSG) ? 500 : 400}
          />
        </div>
        <div className="flex flex-row gap-2 px-3.5 py-2 items-center">
          <ToggleInput
            checked={checkPermission(USER_PERMISSION.UPLOAD_MESAM)}
            handleChange={() => {
              handlePermissionChange(USER_PERMISSION.UPLOAD_MESAM)
            }}
            disabled={!checkPermission(USER_PERMISSION.NEW_RELEASE)}
          />
          <KSpan
            text="Upload MESAM"
            color={isNewRelease ? "#000" : "#00000024"}
            fontWeight={checkPermission(USER_PERMISSION.UPLOAD_MESAM) ? 500 : 400}
          />
        </div>
        <div className="flex flex-row gap-2 px-3.5 py-2 items-center">
          <ToggleInput
            checked={checkPermission(USER_PERMISSION.UPLOAD_BMV)}
            handleChange={() => {
              handlePermissionChange(USER_PERMISSION.UPLOAD_BMV)
            }}
            disabled={!checkPermission(USER_PERMISSION.NEW_RELEASE)}
          />
          <KSpan
            text="Upload BMV"
            color={isNewRelease ? "#000" : "#00000024"}
            fontWeight={checkPermission(USER_PERMISSION.UPLOAD_BMV) ? 500 : 400}
          />
        </div>
        {checkPermission(USER_PERMISSION.UPLOAD_BMV) && (
          <KTooltip
            backgroundColor="#595959"
            width="300px"
            position="top"
            align="center"
            content={
              <KSpan
                color="#FFF"
                text={"BMV Custom Id (Min: 2, Max: 3). Replace with X in example => X_TESTT_Nsax...."}
              />
            }
          >
            {" "}
            <div className="w-full pl-3.5 pr-3">
              <KInput
                value={userInformations?.bmwCustomId || ""}
                padding="14px 12px 14px 14px"
                shadowDisabled
                leftIcon="/analytics_icons/album-record.svg"
                background="#F7F7F7"
                placeholder="BMV Custom Id (Min: 2, Max: 3)"
                onChange={(text: string) => {
                  handleInput("bmwCustomId", text)
                }}
                disabled={!checkPermission(USER_PERMISSION.NEW_RELEASE)}
              />
            </div>
          </KTooltip>
        )}
        <div className="flex flex-row gap-2 px-3.5 py-2 items-center">
          <ToggleInput
            checked={checkPermission(USER_PERMISSION.UPLOAD_STATE51)}
            handleChange={() => {
              handlePermissionChange(USER_PERMISSION.UPLOAD_STATE51)
            }}
            disabled={!checkPermission(USER_PERMISSION.NEW_RELEASE)}
          />
          <KSpan
            text="Upload State51"
            color={isNewRelease ? "#000" : "#00000024"}
            fontWeight={checkPermission(USER_PERMISSION.UPLOAD_STATE51) ? 500 : 400}
          />
        </div>
        {checkPermission(USER_PERMISSION.UPLOAD_STATE51) && (
          <div className="w-full pl-3.5 pr-3">
            <div className="flex flex-row gap-2 px-3.5 py-2 items-center">
              <ToggleInput
                checked={checkPermission(USER_PERMISSION.DO_NOT_SEND_STATE51_FIZY)}
                handleChange={() => {
                  handlePermissionChange(USER_PERMISSION.DO_NOT_SEND_STATE51_FIZY)
                }}
              />
              <KSpan
                text="🚫 Don’t Send to Fizy! 🚫"
                color={"#000"}
                fontWeight={checkPermission(USER_PERMISSION.DO_NOT_SEND_STATE51_FIZY) ? 500 : 400}
              />
            </div>
          </div>
        )}
        {checkPermission(USER_PERMISSION.UPLOAD_STATE51) && (
          <div className="w-full pl-3.5 pr-3">
            <div className="flex flex-row gap-2 px-3.5 py-2 items-center">
              <ToggleInput
                checked={checkPermission(USER_PERMISSION.DO_NOT_SEND_STATE51_MUUD)}
                handleChange={() => {
                  handlePermissionChange(USER_PERMISSION.DO_NOT_SEND_STATE51_MUUD)
                }}
              />
              <KSpan
                text="🚫 Don’t Send to Muud! 🚫"
                color={"#000"}
                fontWeight={checkPermission(USER_PERMISSION.DO_NOT_SEND_STATE51_MUUD) ? 500 : 400}
              />
            </div>
          </div>
        )}
        {checkPermission(USER_PERMISSION.UPLOAD_STATE51) && (
          <div className="w-full pl-3.5 pr-3">
            <div className="flex flex-row gap-2 px-3.5 py-2 items-center">
              <ToggleInput
                checked={checkPermission(USER_PERMISSION.DO_NOT_SEND_STATE51_YOUTUBE_MUSIC_ART)}
                handleChange={() => {
                  handlePermissionChange(USER_PERMISSION.DO_NOT_SEND_STATE51_YOUTUBE_MUSIC_ART)
                }}
              />
              <KSpan
                text="🚫 Don’t Send to Youtube Music/Art! 🚫"
                color={"#000000"}
                fontWeight={checkPermission(USER_PERMISSION.DO_NOT_SEND_STATE51_YOUTUBE_MUSIC_ART) ? 500 : 400}
              />
            </div>
          </div>
        )}
        {checkPermission(USER_PERMISSION.UPLOAD_STATE51) && (
          <div className="w-full pl-3.5 pr-3">
            <div className="flex flex-row gap-2 px-3.5 py-2 items-center">
              <ToggleInput
                checked={checkPermission(USER_PERMISSION.DO_NOT_SEND_STATE51_YOUTUBE_CONTENT_ID)}
                handleChange={() => {
                  handlePermissionChange(USER_PERMISSION.DO_NOT_SEND_STATE51_YOUTUBE_CONTENT_ID)
                }}
                disabled={checkPermission(USER_PERMISSION.UPLOAD_BMV)}
              />
              <KSpan
                text="🚫 Don’t Send to YouTube Content ID! 🚫"
                color={!checkPermission(USER_PERMISSION.UPLOAD_BMV) ? "#000" : "#00000024"}
                fontWeight={checkPermission(USER_PERMISSION.DO_NOT_SEND_STATE51_YOUTUBE_CONTENT_ID) ? 500 : 400}
              />
            </div>
          </div>
        )}
        {checkPermission(USER_PERMISSION.UPLOAD_STATE51) && (
          <div className="w-full pl-3.5 pr-3">
            <div className="flex flex-row gap-2 px-3.5 py-2 items-center">
              <ToggleInput
                checked={checkPermission(USER_PERMISSION.DO_NOT_SEND_STATE51_BEATPORT)}
                handleChange={() => {
                  handlePermissionChange(USER_PERMISSION.DO_NOT_SEND_STATE51_BEATPORT)
                }}
              />
              <KSpan
                text="🚫 Don’t Send to Beatport! 🚫"
                color={"#000"}
                fontWeight={checkPermission(USER_PERMISSION.DO_NOT_SEND_STATE51_BEATPORT) ? 500 : 400}
              />
            </div>
          </div>
        )}
        <div className="flex flex-row gap-2 px-3.5 py-2 items-center">
          <ToggleInput
            checked={checkPermission(USER_PERMISSION.UPLOAD_MARKETING)}
            handleChange={() => {
              handlePermissionChange(USER_PERMISSION.UPLOAD_MARKETING)
            }}
            disabled={!checkPermission(USER_PERMISSION.NEW_RELEASE)}
          />
          <KSpan
            text="Upload Marketing"
            color={isNewRelease ? "#000" : "#00000024"}
            fontWeight={checkPermission(USER_PERMISSION.UPLOAD_MARKETING) ? 500 : 400}
          />
        </div>
        <div className="flex flex-row gap-2 px-3.5 py-2 items-center">
          <ToggleInput
            data-testid="manuel-isrc-entry-permission-toggle"
            checked={checkPermission(USER_PERMISSION.MANUEL_ISRC_ENTRY)}
            handleChange={() => {
              handlePermissionChange(USER_PERMISSION.MANUEL_ISRC_ENTRY)
            }}
            disabled={!checkPermission(USER_PERMISSION.NEW_RELEASE)}
          />
          <KSpan
            text="Manuel Isrc Entry"
            color={isNewRelease ? "#000" : "#00000024"}
            fontWeight={checkPermission(USER_PERMISSION.MANUEL_ISRC_ENTRY) ? 500 : 400}
          />
        </div>
        <div className="flex flex-row gap-2 px-3.5 py-2 items-center">
          <ToggleInput
            data-testid="new-release-create-video-permission-toggle"
            checked={checkPermission(USER_PERMISSION.NEW_RELEASE_CREATE_VIDEO)}
            handleChange={() => {
              handlePermissionChange(USER_PERMISSION.NEW_RELEASE_CREATE_VIDEO)
            }}
            disabled={!checkPermission(USER_PERMISSION.NEW_RELEASE)}
          />
          <KSpan
            text="Create Video Type"
            color={isNewRelease ? "#000" : "#00000024"}
            fontWeight={checkPermission(USER_PERMISSION.NEW_RELEASE_CREATE_VIDEO) ? 500 : 400}
          />
        </div>
      </div>
    )
  }

  const copyLcUsername = () => {
    const username = userInformations.lcUsername.includes("@")
      ? userInformations.lcUsername
      : `${userInformations.lcUsername}@kahunareach.com`
    navigator.clipboard.writeText(username)
    toast.success("LC Username copied to clipboard.", successFilledToastOptions)
  }

  const copyLcPassword = () => {
    navigator.clipboard.writeText(userInformations.lcPassword)
    toast.success("LC Password copied to clipboard.", successFilledToastOptions)
  }

  const onSearchTextChanged = async (text: string) => {
    if (!text) return
    setUserMemberOptions([])
    clearTimeout(userTimeoutId)
    setUserTimeoutId(
      setTimeout(async () => {
        await handleAuthorizedRequest(async () => {
          const roleIds = [USER_ROLE.Artist, USER_ROLE.Collaborator]
          const response = await users(`/?limit=10&offset=0&username=${text}&role__id=${roleIds}`, "get")
          setUserMemberOptions(
            response.data.results.map((optionUser: User) => ({
              value: optionUser.id,
              label: optionUser.username
            }))
          )
        }, "")
      }, 500)
    )
  }

  const renderUserAdvanceMembers = () => {
    return (
      <div className="">
        <div className="mb-2">
          <KTitleSpan text="Members (ADVANCE)" fontSize={20} lineHeight="28px" />
        </div>
        <div>
          {selectedUserAdvanceMembers.map((member) => (
            <div key={member} className="flex items-center gap-2 mb-2">
              <KSpan text={`- ${member}`} color="#000" fontSize={14} />
            </div>
          ))}
          {selectedUserAdvanceMembers.length === 0 && <KSpan text="-" />}
        </div>
      </div>
    )
  }

  const renderUserLabelMembers = () => {
    return (
      <div className="">
        <div className="mb-2">
          <KTitleSpan text="Members (LABEL)" fontSize={20} lineHeight="28px" />
        </div>
        <KDropdown
          dataTestId="members-search-user"
          isMulti={true}
          disableFilterOption={true}
          placeholder={"Search user to filter"}
          closeMenuOnSelect={false}
          selected={selectedUserLabelMembers}
          onInputChange={onSearchTextChanged}
          options={userMemberOptions}
          isClearable={true}
          onSelect={(selectedOption) => {
            if (!selectedOption) {
              setSelectedUserLabelMembers([])
              return
            }
            setSelectedUserLabelMembers(selectedOption as KSelectOption[])
          }}
        />
      </div>
    )
  }

  const renderUserDetail = () => {
    return (
      <div className="flex flex-col gap-6">
        <div className={`flex justify-end`} data-testid="admin-user-create-cancel-button">
          <X className="h-4 cursor-pointer mt-1" style={{ position: "absolute" }} onClick={() => handleClose()} />
        </div>
        <div className="flex flex-col gap-6 items-center justify-center">
          <span
            className="w-[72px] aspect-square rounded-full flex justify-center items-center"
            style={{
              border: "1px solid #F3F3F3"
            }}
          >
            <img className="w-8 h-8" src={isEdit ? "/admin_icons/edit.svg" : "/admin_icons/user-gray.svg"} />
          </span>
          <KTitleSpan text={isEdit ? "User Edit" : "User Create"} fontSize={20} lineHeight="28px" color="#000" />
        </div>
        <div className="custom-scroll flex flex-col gap-6 py-2 px-0.5 max-h-[60vh] overflow-auto">
          <div className="flex flex-col gap-3">
            <div className="flex flex-col gap-2 ">
              <div className="flex flex-row gap-2">
                <div className="w-1/2">
                  <KInput
                    value={userInformations?.firstName || ""}
                    leftIcon="/admin_icons/user-gray.svg"
                    padding="14px 12px 14px 14px"
                    gap="8px"
                    placeholder="Full name"
                    onChange={(text: string) => {
                      handleInput("firstName", text)
                    }}
                  />
                </div>
                <div className="w-1/2">
                  <KInput
                    value={userInformations?.lastName || ""}
                    leftIcon="/admin_icons/user-gray.svg"
                    padding="14px 12px 14px 14px"
                    gap="8px"
                    placeholder="Last name"
                    onChange={(text: string) => {
                      handleInput("lastName", text)
                    }}
                  />
                </div>
              </div>
              <KInput
                value={userInformations?.username || ""}
                leftIcon="/account_icons/mail.svg"
                padding="14px 12px 14px 14px"
                gap="8px"
                placeholder="Username"
                disabled={selectedUser?.id ? true : false}
                onChange={(text: string) => {
                  handleInput("username", text.toLocaleLowerCase())
                }}
              />
              <div className="flex gap-1 items-center">
                <KInput
                  type={showPassword.userPassword ? "text" : "password"}
                  value={userInformations?.password || ""}
                  leftIcon="/admin_icons/lock.svg"
                  autoComplete="new-password"
                  padding="14px 12px 14px 14px"
                  gap="8px"
                  placeholder="Password"
                  rightIcon={showPassword.userPassword ? EyeIconGray : EyeClosedIcon}
                  rightIconClick={() => {
                    const currentState = showPassword.userPassword
                    setShowPassword({ ...showPassword, userPassword: !currentState })
                  }}
                  onChange={(text: string) => {
                    handleInput("password", text)
                  }}
                />
                <KButton
                  width="120px"
                  shadowDisabled
                  background="white"
                  text="Generate Password"
                  onClick={() => handleInput("password", generateStrongPassword())}
                />
              </div>
            </div>
            <div className="flex flex-col gap-3">
              <KTitleSpan text="Labelcamp" fontSize={20} lineHeight="28px" color="#000" />
              <div className="flex flex-col gap-2">
                <div className="flex justify-between">
                  <div className="flex items-center gap-1">
                    <KInput
                      width={185}
                      value={userInformations?.lcUsername?.replace("@kahunareach.com", "") || ""}
                      leftIcon="/admin_icons/user-gray.svg"
                      padding="14px 12px 14px 14px"
                      gap="8px"
                      placeholder="Username"
                      onChange={(text: string) => {
                        handleInput("lcUsername", text.toLocaleLowerCase())
                      }}
                    />
                    <KSpan text="@kahunareach.com" />
                  </div>
                  <div className="cursor-pointer items-center flex" onClick={() => copyLcUsername()}>
                    <img src="/reports_icons/copy-clipboard.svg" width={18} />
                  </div>
                </div>
                <div className="flex justify-between">
                  <div className="flex items-center gap-1">
                    <KInput
                      type={showPassword.lcPassword ? "text" : "password"}
                      value={userInformations?.lcPassword || ""}
                      autoComplete="new-password"
                      leftIcon="/admin_icons/lock.svg"
                      padding="14px 12px 14px 14px"
                      gap="8px"
                      placeholder="Password"
                      rightIcon={showPassword.lcPassword ? EyeIconGray : EyeClosedIcon}
                      rightIconClick={() => {
                        const currentState = showPassword.lcPassword
                        setShowPassword({ ...showPassword, lcPassword: !currentState })
                      }}
                      onChange={(text: string) => handleInput("lcPassword", text)}
                    />
                    <KButton
                      width="120px"
                      shadowDisabled
                      background="white"
                      text="Generate Password"
                      onClick={() => handleInput("lcPassword", generateStrongPassword())}
                    />
                  </div>
                  <div className="cursor-pointer items-center flex" onClick={() => copyLcPassword()}>
                    <img src="/reports_icons/copy-clipboard.svg" width={18} />
                  </div>
                </div>

                <KDropdown
                  dataTestId="label-dropdown"
                  isMulti
                  closeMenuOnSelect={false}
                  selected={labelList}
                  leftIcon="/admin_icons/music-library.svg"
                  padding="14px 12px 14px 14px"
                  gap="8px"
                  isClearable={false}
                  placeholder="Label... (Can be updated after Fetch Label. Delete disabled)"
                  onInputChange={(text: string) => handleLabelInputChange(text)}
                  onSelect={(selected) => setLabelList(selected ? (selected as KSelectOption[]) : [])}
                  options={labelOptions}
                />
                <div className="flex flex-row  items-center justify-between">
                  <div className="flex items-center gap-2">
                    <KButton
                      dataTestId="check-label-info-button"
                      text="Check information"
                      width="96px"
                      height="44px"
                      background="#000"
                      textColor="#FFF"
                      hoverBackground="#111"
                      onClick={() => {
                        checkLabelCampInformations(
                          userInformations?.id,
                          userInformations?.lcUsername,
                          userInformations?.lcPassword
                        )
                      }}
                    />
                    {checkLabelCamp !== undefined && (
                      <img
                        src={checkLabelCamp === true ? CheckCircle : CloseCircle}
                        className="w-5 h-5 min-w-5 min-h-5"
                        alt="labelcamp-checked"
                      />
                    )}
                  </div>
                  <div className="flex gap-2">
                    {labelsFetched ? (
                      <div>
                        <KButton
                          dataTestId="update-label-button"
                          text="Update Labels"
                          width="80px"
                          height="44px"
                          background="black"
                          textColor="white"
                          disabled={labelCampLoading}
                          onClick={() => updateLabelCampUserLabel(userInformations?.id)}
                        />
                      </div>
                    ) : (
                      <div>
                        <KButton
                          dataTestId="fetch-label-button"
                          text="Fetch Label"
                          width="80px"
                          height="44px"
                          background="white"
                          disabled={labelCampLoading}
                          onClick={() => checkLabelCampUserLabel(userInformations?.id)}
                        />
                      </div>
                    )}
                    <div>
                      <KButton
                        dataTestId="invitation-email-button"
                        text="Invitation Email"
                        width="90px"
                        height="44px"
                        background="white"
                        disabled={labelCampLoading}
                        onClick={() => getInvitationEmailUrl(userInformations?.lcUsername)}
                      />
                    </div>
                    <div>
                      <KButton
                        dataTestId="create-lc-user-button"
                        text="Create LC User"
                        width="90px"
                        height="44px"
                        background="white"
                        disabled={labelList.length === 0 || labelCampLoading}
                        onClick={() => createLcUser(userInformations?.lcUsername, userInformations?.lcPassword)}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="flex flex-col gap-3" style={{ width: "100%" }}>
              <div className="flex gap-2" style={{ width: "100%" }}>
                <div style={{ width: "100%" }}>
                  <KTitleSpan text="Genre" fontSize={20} lineHeight="28px" color="#000" />
                  <div className="flex flex-col gap-2">
                    <KDropdown
                      options={genreOptions}
                      selected={genreOptions.find((genreOption) => genreOption?.value2 === userInformations?.genre)}
                      leftIcon="/admin_icons/music-genre.svg"
                      rightIcon="/admin_icons/caret-down.svg"
                      padding="14px 12px 14px 14px"
                      placeholder="Select LC genre"
                      gap="8px"
                      enableIndicator
                      onSelect={(selected) => {
                        const genre = (selected as KSelectOption)?.value2
                        if (genre) {
                          handleInput("genre", genre)
                        }
                      }}
                    />
                  </div>
                </div>
                <div style={{ width: "100%" }}>
                  <KTitleSpan text="Company" fontSize={20} lineHeight="28px" color="#000" />
                  <div className="flex flex-col gap-2">
                    <KDropdown
                      options={countryOptions}
                      selected={countryOptions.find(
                        (companyOption) => companyOption?.label === userInformations?.company
                      )}
                      leftIcon="/navigation_icons/earth.svg"
                      rightIcon="/admin_icons/caret-down.svg"
                      padding="14px 12px 14px 14px"
                      placeholder="Select Company"
                      gap="8px"
                      enableIndicator
                      onSelect={(selected) => {
                        const company = (selected as KSelectOption)?.label
                        if (company) {
                          handleInput("company", company)
                        }
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="flex flex-col gap-3">
            <KTitleSpan text="Artist Spotify ID" fontSize={20} lineHeight="28px" color="#000" />
            <KInput
              value={userInformations?.artistSpotifyId || ""}
              leftIcon="/admin_icons/user-gray.svg"
              padding="14px 12px 14px 14px"
              gap="8px"
              placeholder="64d1rUxfizSAOE9UbMnUZd"
              onChange={(text: string) => {
                handleInput("artistSpotifyId", text)
              }}
            />
          </div>
          {renderUserLabelMembers()}
          {renderUserAdvanceMembers()}
          <div className="flex flex-col gap-3">
            <KTitleSpan text="Permissions" fontSize={20} lineHeight="28px" color="#000" />
            <div className="flex flex-col gap-2">
              <KDropdown
                options={roleOptions}
                selected={roleOptions.find((roleOption) => roleOption?.value === userInformations?.roleId)}
                leftIcon="/admin_icons/user-gray.svg"
                rightIcon="/admin_icons/caret-down.svg"
                padding="14px 12px 14px 14px"
                placeholder="Select user type"
                gap="8px"
                enableIndicator
                onSelect={(selected) => {
                  const roleId = (selected as KSelectOption)?.value
                  handleInput("roleId", roleId)
                }}
              />
              <div className="flex flex-row gap-2 px-3.5 py-2 items-center bg-[#F7F7F7] rounded-[10px]">
                <ToggleInput
                  checked={userInformations.validateEmail}
                  handleChange={() => {
                    const currentState: boolean = userInformations.validateEmail
                    handleInput("validateEmail", !currentState)
                  }}
                />
                <KSpan
                  text="Email validation on authentication"
                  color="#000"
                  fontWeight={userInformations.validateEmail ? 500 : 400}
                />
              </div>
              <div className="flex flex-row gap-2 px-3.5 py-2 items-center bg-[#F7F7F7] rounded-[10px]">
                <ToggleInput
                  checked={checkPermission(USER_PERMISSION.GET_ADVANCE)}
                  handleChange={() => {
                    handlePermissionChange(USER_PERMISSION.GET_ADVANCE)
                  }}
                />
                <KSpan
                  text="Get advance"
                  color="#000"
                  fontWeight={checkPermission(USER_PERMISSION.GET_ADVANCE) ? 500 : 400}
                />
              </div>
              <div className="flex flex-row gap-2 px-3.5 py-2 items-center bg-[#F7F7F7] rounded-[10px]">
                <ToggleInput
                  checked={userInformations.excludeFromProjection}
                  handleChange={() => {
                    const currentState: boolean = userInformations.excludeFromProjection
                    handleInput("excludeFromProjection", !currentState)
                  }}
                />
                <KSpan
                  text="Exclude from projection"
                  color="#000"
                  fontWeight={userInformations.excludeFromProjection ? 500 : 400}
                />
              </div>
              <div className="flex flex-row gap-2 px-3.5 py-2 items-center bg-[#F7F7F7] rounded-[10px]">
                <ToggleInput
                  checked={userInformations.excludeFromPortfolio}
                  handleChange={() => {
                    const currentState: boolean = userInformations.excludeFromPortfolio
                    handleInput("excludeFromPortfolio", !currentState)
                  }}
                />
                <KSpan
                  text="Exclude from portfolio"
                  color="#000"
                  fontWeight={userInformations.excludeFromPortfolio ? 500 : 400}
                />
              </div>
              <div className="flex flex-row gap-2 px-3.5 py-2 items-center bg-[#F7F7F7] rounded-[10px]">
                <ToggleInput
                  checked={userInformations.hideReportTotalAmount}
                  handleChange={() => {
                    const currentState: boolean = userInformations.hideReportTotalAmount
                    handleInput("hideReportTotalAmount", !currentState)
                  }}
                />
                <KSpan
                  text="Hide Report Total Amount"
                  color="#000"
                  fontWeight={userInformations.hideReportTotalAmount ? 500 : 400}
                />
              </div>
              <div className="flex flex-row gap-2 px-3.5 py-2 items-center bg-[#F7F7F7] rounded-[10px]">
                <ToggleInput
                  data-testid="discovery-mode-permission-toggle"
                  checked={checkPermission(USER_PERMISSION.DISCOVERY_MODE)}
                  handleChange={() => {
                    handlePermissionChange(USER_PERMISSION.DISCOVERY_MODE)
                  }}
                />
                <KSpan
                  text="Discovery Mode Edit"
                  color="#000"
                  fontWeight={checkPermission(USER_PERMISSION.DISCOVERY_MODE) ? 500 : 400}
                />
              </div>
              <div className="flex flex-row gap-2 px-3.5 py-2 items-center bg-[#F7F7F7] rounded-[10px]">
                <ToggleInput
                  data-testid="co-manager-permission-toggle"
                  checked={checkPermission(USER_PERMISSION.CO_MANAGER)}
                  handleChange={() => {
                    handlePermissionChange(USER_PERMISSION.CO_MANAGER)
                  }}
                />
                <KSpan
                  text="Co-Manager"
                  color="#000"
                  fontWeight={checkPermission(USER_PERMISSION.CO_MANAGER) ? 500 : 400}
                />
              </div>
              {renderNewReleasePermissions()}
              {!selectedUser?.id && (
                <div className="flex flex-row gap-2 px-3.5 py-2 items-center bg-[#F7F7F7] rounded-[10px]">
                  <ToggleInput
                    checked={userInformations?.sendEmail}
                    handleChange={() => {
                      const currentState: boolean = userInformations?.sendEmail
                      handleInput("sendEmail", !currentState)
                    }}
                  />
                  <KSpan
                    text="Send Credentials Via Email"
                    color="#000"
                    fontWeight={userInformations.sendEmail ? 500 : 400}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="flex gap-3 justify-center items-center">
          <KButton
            dataTestId="admin-user-create-save-and-closebutton"
            text={"Save & Close"}
            disabled={loading}
            onClick={() => {
              const errors = adminUserValidator(userInformations)
              if (Object.keys(errors).length === 0) {
                onUserFormSubmit(userInformations).then(() => {
                  handleClose()
                })
              }
            }}
            background="#fff"
          />
          <KButton
            dataTestId="admin-user-create-save-button"
            text={lang.common.save}
            textColor="white"
            disabled={loading}
            background="black"
            onClick={() => {
              const errors = adminUserValidator(userInformations)
              if (Object.keys(errors).length === 0) {
                onUserFormSubmit(userInformations).then(() => {
                  // handleClose()
                })
              }
            }}
          />
        </div>
      </div>
    )
  }

  const renderUserCredits = () => {
    return (
      <div>
        <AdminUserCreditModal open={true} onClose={onClose} user={selectedUser} isModal={false} />
      </div>
    )
  }

  const renderAgreementsPayout = () => {
    return (
      <div style={{ height: "92vh" }}>
        <AdminAgreementsPayoutModal
          open={selectedTab === TabOptions.AGREEMENTS_PAYOUT}
          paymentMethodsAdminEntry={paymentMethodsAdminEntry}
          onClose={handleClose}
          user={selectedUser}
          onUserExpenseFormSubmit={onUserExpenseFormSubmit}
          loggedInUser={loggedInUser}
          selectedUserExpense={selectedUserExpense}
          isModal={false}
          userHasUpdateCount={userHasUpdateCount}
          updateUserHasUpdateCount={updateUserHasUpdateCount}
          userUnverifiedContractCount={userUnverifiedContractCount}
          updateUserUnverifiedContractCount={updateUserUnverifiedContractCount}
          userPaymentMethodUpdatedCount={userPaymentMethodUpdatedCount}
          updateUserPaymentMethodUpdatedCount={updateUserPaymentMethodUpdatedCount}
        />
      </div>
    )
  }

  const renderSmartLinks = () => {
    return (
      <div style={{ height: "92vh" }}>
        <AdminSmartLinkArtistModal
          open={selectedTab === TabOptions.AGREEMENTS_PAYOUT}
          onClose={handleClose}
          user={selectedUser}
          isModal={false}
        />
      </div>
    )
  }

  return (
    <Dialog open={open} onClose={handleClose}>
      <div className="fixed w-screen h-screen top-0 left-0 z-250 flex items-center justify-center bg-[#0000004d] ">
        <div
          className={`p-6 shadow-md ${
            selectedTab === TabOptions.DETAIL && "w-[650px]"
          } rounded-[10px] bg-[#fff] flex gap-4`}
        >
          <div className="flex flex-col gap-2" style={{ borderRight: "1px solid grey" }}>
            <KTooltip
              position="left"
              content={
                <KSpan
                  text={TabOptions.DETAIL}
                  fontWeight={selectedTab === TabOptions.DETAIL ? 600 : 400}
                  color={selectedTab === TabOptions.DETAIL ? "#111" : ""}
                />
              }
              children={
                <div
                  className="cursor-pointer"
                  onClick={() => setSelectedTab(TabOptions.DETAIL)}
                  style={{ width: "46px" }}
                >
                  <img className="min-w-5 min-h-5" src={"/admin_icons/edit.svg"} width={24} />
                </div>
              }
            />

            <KTooltip
              width="155px"
              position="left"
              content={
                <KSpan
                  text={TabOptions.USER_CREDITS}
                  fontWeight={selectedTab === TabOptions.USER_CREDITS ? 600 : 400}
                  color={selectedTab === TabOptions.USER_CREDITS ? "#111" : ""}
                />
              }
              children={
                <div
                  className="cursor-pointer mt-2"
                  onClick={() =>
                    selectedUser.id
                      ? setSelectedTab(TabOptions.USER_CREDITS)
                      : toast.error("Please save user to access User Credits")
                  }
                  style={{ width: "46px" }}
                >
                  <img className="min-w-5 min-h-5" src={"/admin_icons/shopping-bag.svg"} width={24} />
                </div>
              }
            />

            <KTooltip
              width="155px"
              position="left"
              content={
                <KSpan
                  text={TabOptions.AGREEMENTS_PAYOUT}
                  fontWeight={selectedTab === TabOptions.AGREEMENTS_PAYOUT ? 600 : 400}
                  color={selectedTab === TabOptions.AGREEMENTS_PAYOUT ? "#111" : ""}
                />
              }
              children={
                <div
                  className="cursor-pointer mt-2"
                  onClick={() =>
                    selectedUser.id
                      ? setSelectedTab(TabOptions.AGREEMENTS_PAYOUT)
                      : toast.error("Please save user to access Agreements & Payouts")
                  }
                  style={{ width: "46px" }}
                >
                  <img className="min-w-5 min-h-5" src={"/admin_icons/contract-icon.svg"} width={24} />
                </div>
              }
            />

            <KTooltip
              position="left"
              width="135px"
              content={
                <KSpan
                  text={TabOptions.SMART_LINK_ARTIST}
                  fontWeight={selectedTab === TabOptions.SMART_LINK_ARTIST ? 600 : 400}
                  color={selectedTab === TabOptions.SMART_LINK_ARTIST ? "#111" : ""}
                />
              }
              children={
                <div
                  className="cursor-pointer mt-2"
                  onClick={() => setSelectedTab(TabOptions.SMART_LINK_ARTIST)}
                  style={{ width: "46px" }}
                >
                  <img className="min-w-5 min-h-5" src={"/analytics_icons/link.svg"} width={24} />
                </div>
              }
            />
          </div>
          {selectedTab === TabOptions.DETAIL && <div>{renderUserDetail()}</div>}
          {selectedTab === TabOptions.USER_CREDITS && <div>{renderUserCredits()}</div>}
          {selectedTab === TabOptions.AGREEMENTS_PAYOUT && <div>{renderAgreementsPayout()}</div>}
          {selectedTab === TabOptions.SMART_LINK_ARTIST && <div>{renderSmartLinks()}</div>}
        </div>
      </div>
    </Dialog>
  )
}

const mapStateToProps = (state: RootState) => {
  return {
    selectedUser: state.admin.selectedUser,
    loggedInUser: state.auth.user,
    selectedUserExpense: state.admin.selectedUserExpense,
    userHasUpdateCount: state.admin.userHasUpdateCount,
    userUnverifiedContractCount: state.admin.userUnverifiedContractCount,
    userPaymentMethodUpdatedCount: state.admin.userPaymentMethodUpdatedCount
  }
}

export default connect(mapStateToProps, {
  selectUser,
  paymentMethodsAdminEntry,
  saveUserExpenseData,
  fetchUserExpenseData,
  saveUser,
  updateUserHasUpdateCount,
  updateUserUnverifiedContractCount,
  updateUserPaymentMethodUpdatedCount
})(AdminUserCreateModal)
